// extracted by mini-css-extract-plugin
export default {"container-menu":"style_container-menu__NsyK5","menu-item":"style_menu-item__czmj9","arrow":"style_arrow__HWO8D","menu-ink":"style_menu-ink__9riwm"};